// extracted by mini-css-extract-plugin
export default {"box":"mastersVrpFilterPage_box__dONOw","box__content":"mastersVrpFilterPage_box__content__fPATI","box__btn":"mastersVrpFilterPage_box__btn__leJSW"};